module.exports = __webpack_public_path__ + "img/loading.1db6d4bf.gif";